import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Previous = ({ className }: Props) => {
    const { t } = useGranite();
    const { currentStep, previousStep, canGoBack, steps } =
        usePaintConfiguratorContext();

    if (!currentStep || !canGoBack) return null;

    const previousStepLabel = steps.at(currentStep.index - 1)?.meta.name;

    return (
        <Button
            color={"link"}
            onClick={previousStep}
            className={cn("tw:p-0", className)}
        >
            <span className={cn("las la-xs la-angle-left")}></span>
            {t("paintConfigurator.navigation.previous", previousStepLabel)}
        </Button>
    );
};
